import { Link } from "react-router-dom";
import { format } from "date-fns";
import { MapPin, Users } from "lucide-react";
import { media, money } from "@/lib/api";

export const fmtDate = (s, f = "EEE, MMM d · h:mm a") => {
  try { return format(new Date(s), f); } catch { return ""; }
};

export const CreatorPhoto = ({ creator, className = "" }) => {
  const src = media(creator?.profile_pic);
  const initials = (creator?.name || "?").split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();
  return src ? (
    <img src={src} alt={creator?.name} className={`h-full w-full object-cover ${className}`} />
  ) : (
    <div className={`h-full w-full grid place-items-center bg-[#1C1917] ${className}`}>
      <span className="font-display font-black text-7xl text-[#FF5C00]">{initials}</span>
    </div>
  );
};

export const EventCard = ({ event: e, index = 0 }) => {
  const c = e.creator || {};
  const spots = e.max_attendees ? e.max_attendees - (e.attendee_count || 0) : null;
  return (
    <Link to={`/events/${e.id}`} data-testid={`event-card-${e.id}`}
      className="group rise block rounded-3xl bg-white border border-stone-200/80 overflow-hidden hover:-translate-y-1 hover:shadow-[0_18px_40px_-18px_rgba(28,25,23,.35)] transition-[transform,box-shadow] duration-300"
      style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}>
      <div className="aspect-[4/3] relative overflow-hidden bg-stone-200">
        <CreatorPhoto creator={c} className="group-hover:scale-105 transition-transform duration-700" />
        <div className="absolute inset-0 bg-gradient-to-t from-stone-950/90 via-stone-950/30 to-transparent" />
        <span className="absolute top-3 left-3 font-mono text-xs font-semibold bg-white/95 px-2.5 py-1 rounded-full">{money(e.price)}</span>
        {e.distance_miles != null && (
          <span className="absolute top-3 right-3 font-mono text-xs bg-stone-900/80 text-white px-2.5 py-1 rounded-full">{e.distance_miles} mi</span>
        )}
        <div className="absolute bottom-0 inset-x-0 p-4 text-white">
          {e.cancelled ? <span className="font-mono text-[10px] bg-red-600 px-2 py-0.5 rounded-full">Cancelled</span>
            : spots != null && spots <= 5 && <span className="font-mono text-[10px] bg-[#FF5C00] px-2 py-0.5 rounded-full">{spots > 0 ? `${spots} spots left` : "Sold out"}</span>}
          <p data-testid={`event-card-creator-${e.id}`} className="mt-1.5 font-display text-2xl font-black leading-none tracking-tight">{c.name || "Creator"}</p>
          <p data-testid={`event-card-title-${e.id}`} className="mt-1 text-sm font-semibold text-white/95 line-clamp-1">{e.title}</p>
          {c.city && <p className="text-xs text-stone-300">{c.city}</p>}
        </div>
      </div>
      <div className="px-4 py-3">
        <p className="font-mono text-[11px] uppercase tracking-widest text-[#C2410C]">{fmtDate(e.start_time)}</p>
        <div className="mt-1 flex items-center gap-3 text-sm text-stone-500">
          <span className="flex items-center gap-1 truncate"><MapPin className="h-3.5 w-3.5 shrink-0" />{e.location_name}</span>
          <span className="flex items-center gap-1 shrink-0"><Users className="h-3.5 w-3.5" />{e.attendee_count || 0}{e.max_attendees ? `/${e.max_attendees}` : ""}</span>
        </div>
      </div>
    </Link>
  );
};
